// demo: false, - strange var

import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const taskList = {
    "id": "JBp2OR",
    "name": "Task List",
    "img": "/app/static/templates/it/testing.jpg",
    "description": "Simple task list",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Demo projects',
    demoFolderColor: 21
};

const waterfall = {
    "id": "H8Kyhe",
    "name": "Project with phases",
    "img": "/app/static/templates/pm/phases.jpg",
    "description": "General project structure with logical sequential stages.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Demo projects',
    demoFolderColor: 21
};

const scrumProject = {
    "id": "E187a5",
    "name": "Scrum Project",
    "img": "/app/static/templates/software/scrum-software.jpg",
    "description": "Pre-configured backlog and sprints to run your scrum project.",
    setupDemoProject: 'Demo projects',
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    demoFolderColor: 21
};

const gantt = {
    "id": "VwOdR3",
    "name": "Gantt Project",
    "img": "/app/static/templates/pm/dependencies.jpg",
    "description": "Sample project with the Gantt planning and timeline at the center.",
    setupDemoProject: 'Demo projects',
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    demoFolderColor: 21
};

const kanban = {
    "id": "PYXc54",
    "name": "Kanban Project",
    "img": "/app/static/templates/product/product-backlog.jpg",
    "description": "Kanban board based demo project",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Demo projects',
    demoFolderColor: 21
};

const serviceProject = {
    "id": "U0kEhA",
    "name": "Service Project",
    "img": "/app/static/templates/pm/service-project.jpg",
    "description": "Template perfect for agencies, contractors, and consultants.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Demo projects',
    demoFolderColor: 21
};


export default {
    id: 'project-management',
    name: "Project Management",
    items: [
        taskList,
        waterfall,
        scrumProject,
        gantt,
        kanban,
        serviceProject,
    ]
};


// Below is old code

/*
const simpleProject = {
    "id": "MfLWlW",
    "name": "Empty Project",
    "img": "/app/static/templates/project.jpg",
    "description": "Use project to organize work items with a common goal.",
    systemType: ProjectSystemType.PROJECT,
    demo: false,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const waterfall = {
    "id": "H8Kyhe",
    "name": "Waterfall Project",
    "img": "/app/static/templates/waterfall.jpg",
    "description": "Project structure built to align with waterfall methodology.",
    systemType: ProjectSystemType.PROJECT,
    demo: '/',
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const scrumProject = {
    "id": "E187a5",
    "name": "Scrum Project",
    "img": "/app/static/templates/scrum.jpg", // https://image.shutterstock.com/image-vector/scrum-agile-methodology-software-development-260nw-256253887.jpg
    "description": "Pre-configured backlog and sprints to run your scrum project.",
    systemType: ProjectSystemType.PROJECT,
    setupDemoProject: '/',
    copyToLocalTemplate: false,
    wipeTemplateContent: true,
    demoFolderColor: 21
};

const taskList = {
    "id": "JBp2OR",
    "name": "Task List",
    "img": "/app/static/templates/list.jpg",
    "description": "Track your todo’s and focus on moving tasks forward to completion.",
    systemType: ProjectSystemType.FOLDER,
    demo: false,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const kanban = {
    "id": "PYXc54",
    "name": "Kanban Project",
    "img": "/app/static/templates/board.jpg",
    "description": "Use this digital board to plan your initiatives and execute on them.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const gantt = {
    "id": "VwOdR3",
    "name": "Gantt Project",
    "img": "/app/static/templates/gantt.jpg",
    "description": "Sample project with the Gantt planning and timeline at the center.",
    systemType: ProjectSystemType.PROJECT,
    setupDemoProject: '/',
    copyToLocalTemplate: false,
    wipeTemplateContent: true,
    demoFolderColor: 21
};

const serviceProject = {
    "id": "U0kEhA",
    "name": "Service Project",
    "img": "/app/static/templates/pm/service-project.jpg",
    "description": "Template perfect for agencies, contractors, and consultants.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'projectManagement',
    wipeTemplateContent: true,
    demoFolderColor: 21
};

const softwareProject = {
    "id": "j7Bg5w",
    "name": "Software Development",
    "img": "/app/static/templates/software/application.jpg",
    "description": "Generic software development template.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'projectManagement',
    demoFolderColor: 21
    // wipeTemplateContent: true,
};

const designProject = {
    "id": "Ai7OTz",
    "name": "Design project",
    "img": "/app/static/templates/design/design-project.jpg",
    "description": "Project structure build to manage phases of a creative project.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'projectManagement',
    wipeTemplateContent: true,
    demoFolderColor: 21
};


module.exports = {
    id: 'project-management',
    name: "Project Management",
    items: [
        simpleProject,
        waterfall,
        scrumProject,
        taskList,
        kanban,
        gantt,
        serviceProject,
        softwareProject,
        designProject

    ]
};
*/